module.exports = __webpack_public_path__ + "img/au.e875a51.svg";